import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

import Header from "./components/Header";
import pdfImage from "../img/pdf-icon.png";

const Step10_Confirmation = () => {

    const [resources, setResources] = useState({});
    const [order, setOrder] = useState({});
    const [organizerId, setOrganizerId] = useState("");
    const [token, setToken] = useState("");

    const [error, setError] = useState(null);

    // fetching resources and orderId
    const { language, orderId } = useParams();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    useEffect(() => {
        loadToken();
    }, []);

    useEffect(() => {
        requestResources();
        requestFormSettings();
    }, [language, token]);

    const loadToken = async () => {
        await axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
            setToken(res.data);
        });
    };

    const requestFormSettings = () => {
        axios.get(`form/formsettings`).then((res) => {
            setOrganizerId(res.data.organizerId);
            loadOrder(orderId);
        });
    };

    const loadOrder = async (orderId, attempt = 1) => {
        try {
            const fetchedOrder = await getOrderByOrderId(orderId);

            // If invoiceNumber missing and attempts < 7, retry
            if ((!fetchedOrder?.invoiceNumber || fetchedOrder.invoiceNumber === "") && attempt < 7) {
                console.log(`Retrying to fetch order... Attempt ${attempt + 1}`);
                await new Promise((resolve) => setTimeout(resolve, 2000)); // optional delay before retry
                return loadOrder(orderId, attempt + 1);
            }

            if (!fetchedOrder?.invoiceNumber) {
                setError("Invoice number is missing after multiple attempts.");
            } else {
                setError(null);
            }

            setOrder(fetchedOrder);
        } catch (error) {
            console.error(error);
            setError("Failed to load order.");
        }
    };

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const requestResources = () => {
        axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const getPdfTicketsOfOrder = async () => {
        await axios
            .get(
                `${baseUrl}/Order/${orderId}/TicketsPdf?organizerId=${organizerId}`,
                {
                    responseType: "blob",
                }
            )
            .then((res) => {
                const data = window.URL.createObjectURL(res.data);
                var link = document.createElement("a");
                link.href = data;
                link.download = "Ticket.pdf";
                link.click();
            })
            .catch((error) => console.error(error.response.data));
    };

    const getReceiptOfOrder = async () => {
        await axios
            .get(`${baseUrl}/Order/${orderId}/Receipt?organizerId=${organizerId}`, {
                responseType: "blob",
            })
            .then((res) => {
                const data = window.URL.createObjectURL(res.data);
                var link = document.createElement("a");
                link.href = data;
                link.download = "Quittung.pdf";
                link.click();
            })
            .catch((error) => console.error(error.response.data));
    };

    return (
        <div>
            {/* header */}
            <div className="container wrapper">
                <div className="row">
                    <div className="col-md-12">
                        <Header language={language} />
                    </div>
                </div>
            </div>

            {resources && (
                <div className="container wrapper">
                    <div className="m-5">

                        {/* Show error message if any */}
                        {error && (
                            <div className="alert alert-danger" role="alert">
                                <p dangerouslySetInnerHTML={{ __html: resources?.ErrorOrder?.replaceAll("${orderId}", orderId) }}></p>
                            </div>
                        )}

                        {!error && order && order.invoiceNumber && order.invoiceNumber !== 0 && (
                            <>
                                <div className="row">
                                    <div className="col-md-12 mb-2">
                                        <h1>
                                            Vielen Dank für Ihre Anmeldung.
                                        </h1>
                                    </div>
                                </div>
                                <div className="mt-4">
                                    <div className="row">
                                        <div className="col-md-6 ">
                                            <p>Ihre Bestell-Nr. lautet {order.invoiceNumber && order.invoiceNumber}</p>
                                            <p>
                                                Bitte notieren Sie Ihre Bestell-Nr. für allfällige
                                                Support-Anfragen. <br></br>
                                                Sie erhalten in Kurze eine Bestellbestätigung per E-Mail.
                                            </p>
                                            <p>
                                                Laden Sie jetzt Ihr Ticket herunter und drucken Sie es aus.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-8 mt-4">
                                            <img src={pdfImage} className="pdf-icon" alt="car picture"></img>
                                            <button
                                                className="custom-button form-control pdf-button"
                                                onClick={() => getPdfTicketsOfOrder()}
                                            >
                                                TICKET HERUNTERLADEN
                                            </button>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-8 mt-4">
                                            <img src={pdfImage} className="pdf-icon" alt="car picture"></img>
                                            <button
                                                className="custom-button form-control pdf-button"
                                                onClick={() => getReceiptOfOrder()}
                                            >
                                                QUITTUNG HERUNTERLADEN
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    <p className="mt-5 text-center">
                        {resources && (
                            <small style={{ color: 'grey', fontSize: '12px' }}>powered by <a style={{ color: 'grey' }} href={resources._TicketinoOrganizerUrl} target="_blank">TICKETINO</a></small>
                        )}
                    </p>
                </div>
            )}
        </div>
    );
};

export default Step10_Confirmation;
